import template from './thesafezone.html';
import './thesafezone.styl';

function thesafezoneComponent($location, $anchorScroll) {

  'ngInject';

  this.scrollTo = (id) => {
    // set the location.hash to the id of
    // the element you wish to scroll to.
    $location.hash(id);

    // call $anchorScroll()
    $anchorScroll();
  };
}

export default {
  template,
  controller: thesafezoneComponent,
};



// WEBPACK FOOTER //
// ./src/containers/thesafezone/index.js